import { createFileRoute } from '@tanstack/react-router'
import TeacherService from '@/components/teacherPage/TeacherService'
import { guardTeacherOnly } from '@/lib/auth/routeGuards'

export const Route = createFileRoute('/teacher/')({
  component: TeacherLayout,
  beforeLoad: guardTeacherOnly,
})

function TeacherLayout() {
  return <TeacherService />
}
